import Header from "../header";
import Admin from "./adminpanel";
import Footer from "../footer";

function Main() {
  return (
    <div>
      <Header />
      <Admin />
      <Footer />
    </div>
  );
}

export default Main;
